var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1742_29472)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78207 12L0.396075 14.3385C0.276266 14.4025 0.176092 14.4979 0.106247 14.6144C0.0364033 14.7309 -0.000488281 14.8642 -0.000488281 15C-0.000488281 15.1358 0.0364033 15.2691 0.106247 15.3856C0.176092 15.5021 0.276266 15.5975 0.396075 15.6615L11.6461 21.6615C11.7546 21.7193 11.8756 21.7495 11.9986 21.7495C12.1215 21.7495 12.2426 21.7193 12.3511 21.6615L23.6011 15.6615C23.7209 15.5975 23.8211 15.5021 23.8909 15.3856C23.9607 15.2691 23.9976 15.1358 23.9976 15C23.9976 14.8642 23.9607 14.7309 23.8909 14.6144C23.8211 14.4979 23.7209 14.4025 23.6011 14.3385L19.2196 12L17.6251 12.8505L21.6571 15L12.0001 20.1495L2.34307 15L6.37508 12.8505L4.78058 12H4.78207Z",
    fill: "#636E72"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6475 2.33849C11.7561 2.28071 11.8771 2.25049 12 2.25049C12.123 2.25049 12.244 2.28071 12.3525 2.33849L23.6025 8.33849C23.7223 8.4025 23.8225 8.49785 23.8924 8.61436C23.9622 8.73086 23.9991 8.86415 23.9991 8.99999C23.9991 9.13583 23.9622 9.26911 23.8924 9.38562C23.8225 9.50213 23.7223 9.59748 23.6025 9.66149L12.3525 15.6615C12.244 15.7193 12.123 15.7495 12 15.7495C11.8771 15.7495 11.7561 15.7193 11.6475 15.6615L0.397539 9.66149C0.277731 9.59748 0.177557 9.50213 0.107712 9.38562C0.0378681 9.26911 0.000976562 9.13583 0.000976562 8.99999C0.000976562 8.86415 0.0378681 8.73086 0.107712 8.61436C0.177557 8.49785 0.277731 8.4025 0.397539 8.33849L11.6475 2.33849ZM2.34454 8.99999L12 14.1495L21.657 8.99999L12 3.85049L2.34304 8.99999H2.34454Z",
    fill: "#636E72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1742_29472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.02f8d914.svg";
export { ForwardRef as ReactComponent };